// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2372":"aa1ef348","4114":"47806afa","8080":"aa1ef348","9925":"2aa3be2f"}[chunkId] + ".chunk.css";
};